import React, { useContext, useEffect, useRef, useState } from 'react';
import { useField, useFormikContext } from 'formik';

import { formatLabel } from '../../utils/utils';

// import styled from "@emotion/styled";
import { SaisieContext } from '../formConteneur';
import { Aide } from '../autres/aide';
import { EtapesSaisieContext } from '../../App';
import { Simulation } from '../../types/main';

export interface MyListeBoutonsProps {
  label: string;
  name: keyof Simulation;
  id?: string;
  required?: boolean;
  labelAvecRC?: JSX.Element;
  toucheRC?: string[];
  matchTouchesElement?: number[];
  autoFocus?: boolean;
  validate?: (value: number | string) => string;
  onFocus?: () => void;
  onBlur?: () => void;
  forceTabIndex?: number;
  format?: string;
  disabled?: boolean;
  disabledReadable?: boolean;
  periode?: string;
  aide?: string;
  classes?: string[];
  boutons: string[];
  boutonsDesactives?: string[];
  // onMouseLeave?: (event: React.MouseEvent<EventTarget>) => void;
}
export const MyListeBoutons: React.FC<MyListeBoutonsProps> = (props) => {
  // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
  // which we can spread on <input> and alse replace ErrorMessage entirely.
  const [focus, setFocus] = useState(false);
  const { modeAffichage, setModeAffichage } = useContext(SaisieContext);
  const { values, setFieldValue } = useFormikContext();
  const { changeEtapes } = useContext(EtapesSaisieContext);
  // const { dimensions } = useContext(ResponsiveContext);
  // const [field] = useField(props);
  const simulation = values as Simulation;
  const { filiere, sous_filiere } = simulation;

  const { label, id, name, labelAvecRC, toucheRC, matchTouchesElement,
    disabled,
    forceTabIndex, format, periode, disabledReadable, aide, classes,
    boutons, boutonsDesactives,
  } = props;
  const myprops = { ...props, type:"text" };
  delete myprops.forceTabIndex;
  delete myprops.labelAvecRC;
  delete myprops.toucheRC;
  delete myprops.classes;

  const _format = format ? format : '';
  const _periode = periode ? periode : '';

  const ref = useRef<HTMLSelectElement>(null);

  useEffect(() => {
    // console.log('useEffect de MyListeBoutons, name =', name);
    
    switch (name) {
      case 'filiere':
        changeEtapes([], 1);
        break;
      case 'specialite':
        changeEtapes([], 2);
        break;
      case 'latin_ou_grec':
        // changeEtapes([], 3);
        break;
      default:
        break;
    }
    setFieldValue(name, '');
  }, []);

  // event: React.FocusEvent<EventTarget> si jamais
  const handleClick = (element: string): void => {
    setFieldValue(name, element);
    // setTimeout(() => nextEtapeSaisie(), 200);
  }

  // useEffect(() => {
  //   if (valide) {
  //     alert('apres valide name =' + simulation[name as keyof (Simulation & CCSimulation)]);
  //     setTimeout(() => nextEtapeSaisie(), 3000);
  //   }
  // }, [simulation[name as keyof (Simulation & CCSimulation)]]);

  useEffect(() => {
    const handleRC = (event: KeyboardEvent): void => {
      if (toucheRC && matchTouchesElement && toucheRC.includes(event.key)) {
        event.preventDefault();
        setFieldValue(name, boutons[matchTouchesElement[toucheRC.indexOf(event.key)]]);
      }
    }
    
    window.addEventListener('keydown', handleRC);

    return (): void => {
      window.removeEventListener('keydown', handleRC);
    };
  }, [modeAffichage, toucheRC, setModeAffichage]);

  useEffect(() => {
    if (focus && !modeAffichage) {
      if (ref.current) {
        ref.current!.focus();
        setFocus(false);
      }
    }
  }, [modeAffichage, focus]);

  useEffect(() => {
    if (label === 'Choix du client') {
      if (ref.current) {
        ref.current.focus();
      }
    }
  }, [label]);

  const classNameBoutons = classes ? [...classes] : [];
  const classNameDivGen = classes ? [...classes] : [];
  classNameDivGen.push('label-div');
  const classNameDivSaisieGen = classes ? [...classes] : [];
  classNameDivSaisieGen.push('label-select');

  const _className = ['div_input'];
  if (disabledReadable) _className.push('disabledReadable');
  const _classNameSelect = [];
  if (disabledReadable) _classNameSelect.push('disabledReadable');

  let ret = <></>;
  let baliseLabel = <label htmlFor={id || name}>{label}{formatLabel(_format, _periode)}</label>;
  if (labelAvecRC) {
    baliseLabel = <label htmlFor={id || name}>{labelAvecRC}{formatLabel(_format, _periode)}</label>
  }
  const elementLabel = label === '' ? <></> : baliseLabel;
  const elementLabelDiv = label === '' ? <></>
    : <label htmlFor={id || name}>
      {modeAffichage && labelAvecRC ?
        labelAvecRC + formatLabel(_format, _periode)
        : label + formatLabel(_format, _periode)}
    </label>;

  return <div className="listeBoutons">
    {boutons.map((element, index) => {
      return (
        <button
          key={`bouton_${index}`}
          onClick={() => handleClick(element)}
          className={classNameBoutons.join(' ')}
          type="button"
          title={boutonsDesactives && boutonsDesactives.includes(element) ? 'Bientôt disponible' : ''}
          disabled={boutonsDesactives && boutonsDesactives.includes(element)}
        >
        {element}
        </button>
      )
    })}
  </div>
};
